module.exports = __webpack_public_path__ + "static/media/arrow-right-outline-color.1d368325.svg";